import { render, staticRenderFns } from "./Opens.vue?vue&type=template&id=2470006c&scoped=true"
import script from "./Opens.vue?vue&type=script&lang=js"
export * from "./Opens.vue?vue&type=script&lang=js"
import style0 from "./Opens.vue?vue&type=style&index=0&id=2470006c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470006c",
  null
  
)

export default component.exports